import {
    Drawer,
    Button,
    Table,
    Row,
    Col,
    Space,
    Divider,
    Upload,
    Card,
    Spin,
  } from "antd";
  import {
    ArrowDownOutlined,
    CheckCircleOutlined,
    DeleteOutlined,
    ExclamationCircleOutlined,
    InboxOutlined,
    WarningOutlined,
    CloseCircleOutlined,
  } from "@ant-design/icons";
  import { useForm } from "antd/lib/form/Form";
  import { useState } from "react";
  import { useDispatch, useSelector } from "react-redux";
  import { RootState } from "../../../shared/types/common";
  import { encryptCTC, showNotification } from "../../../shared/utils/utils";
  import { error } from "console";
  import { projectBulkImport } from "../../../core/store/reducers/project.slice";
  import Papa from "papaparse";
  
  interface Props {
    onClose: () => void;
    visible: boolean;
    selectedEntity?: any;
    onSubmit?: () => void;
  }
  
  // type FileType = Parameters<GetProp<UploadProps, 'beforeUpload'>>[0];
  
  const ProjectBulkUploadComponent = ({
    onClose,
    visible,
    selectedEntity = null,
    onSubmit = () => {
      return;
    },
  }: Props) => {
    const dispatch = useDispatch();
    const [form] = useForm();
    const { user } = useSelector((state: RootState) => state.auth);
    const { screenType } = useSelector((state: RootState) => state.settings);
    const [fileList, setFileList] = useState<File[]>([]);
    const [parsedData, setParsedData] = useState<any[]>([]);
    const [errorData, setErrorData] = useState<any[]>([]);
    const [importSuccess, setImportSuccess] = useState(false);
    const [resultLoading, setResultLoading] = useState(false);
    const [numberRowCSV, setnumberRowCSV] = useState(0);
    const [importError, setImportError] = useState(false);  
    // State to manage the current phase
    const [currentPhase, setCurrentPhase] = useState<
      "preparation" | "precheck" | "processing"
    >("preparation");
  
    // State to store validation errors for display
    const [validationErrors, setValidationErrors] = useState<any[]>([]);
  
    // State for file information after successful upload
    const [fileInfo, setFileInfo] = useState<any>({
      name: "",
      size: 0,
      rows: 0,
    });
  
    const handleNext = () => {
      // Transition to the next phase
      if (currentPhase === "preparation") {
        // Perform validations or checks before transitioning to precheck
        // For demonstration, let's assume it's successful and move to precheck
        setCurrentPhase("processing");
        onFinish();
      } else if (currentPhase === "precheck") {
        // Transition to processing phase
        setCurrentPhase("processing");
      }
    };
  
    const handlePrevious = () => {
      // Transition to the previous phase
      if (currentPhase === "precheck") {
        // Go back to preparation phase
        setCurrentPhase("preparation");
      } else if (currentPhase === "processing") {
        // Go back to precheck phase
        setCurrentPhase("preparation");
        setErrorData([]);
      }
    };
  
    const handleDownloadTemplate = () => {
      // Create a temporary link element
      const pom = document.createElement("a");
  
      // Set the href attribute to the path of the CSV file
      pom.href =
        "data:text/csv;charset=utf-8," +
        encodeURIComponent(
          `ENTITY,CLIENT,SOW/QUOTATION_NUMBER,PO_NUMBER,PROJECT_TYPE,PROJECT_NAME,START_DATE,END_DATE,ACCOUNT_MANAGER_NAME,PROJECT_MANAGER_NAME,PO_CURRENCY,PO_VALUE,MARGIN,STATUS`,

        );
  
      // Set the download attribute to specify the file name
      pom.setAttribute("download", "PROJECT BULK IMPORT V1.csv");
  
      // Simulate a click event on the link to trigger the download
      pom.click();
    };
  
    const handleDeleteFile = () => {
      // Filter out the file with the specified index
      setFileList([]);
      showNotification(` File Removed Successfully.`, "success");
    };
  
    const columns = [
      {
        title: "File Name",
        dataIndex: "name",
        key: "name",
      },
      {
        title: "File Size",
        dataIndex: "size",
        key: "size",
        render: (size: any) => `${(size / 1024 / 1024).toFixed(2)} MB`,
      },
      {
        title: "Actions",
        key: "actions",
        render: (index: any) => (
          <Space>
            <Button
              type="link"
              onClick={() => handleDeleteFile()}
              icon={<DeleteOutlined style={{color:"#FF0000"}} />}
            ></Button>
          </Space>
        ),
      },
    ];
  
    const fileData = [
      {
        title: "Row",
        dataIndex: "index",
        key: "index",
      },
      {
        title: "Feild Name",
        dataIndex: "fields",
        key: "fields",
      },
      {
        title: "Error",
        dataIndex: "message",
        key: "message",
      },
    ];
  
    const onFinishFailed = (errorInfo: any) => {
      // Handle form validation failure
      // For demonstration, let's just set the validation errors
      setValidationErrors(errorInfo.errorFields);
    };
  
    const onFinish = () => {
      const jsonData = JSON.stringify(parsedData);
      const data = {
        file: jsonData,
      };
      if(!errorData?.length){
        setResultLoading(true);
      dispatch(projectBulkImport(data)).then((val: any) => {
        setErrorData([])
        if (val?.payload?.data && val?.payload?.data?.statusCode === 200) {
            setImportError(false);
          setImportSuccess(true);
          
          showNotification("project Created Successfully", "success");
          onSubmit();
          setResultLoading(false);
        }else if (val?.payload?.data && val?.payload?.data?.status === 400) {
          setResultLoading(false);
          setImportSuccess(false);
          
          let error = val?.payload?.data?.response?.error;
          let fieldError = [];
          let err = [];
  
          if (error?.type === "INVALID_HEADER") {
            const err = error?.data || [];
            for (let j = 0; j < err.length; j++) {
              fieldError.push({
                Column: err[j]?.index ,
                "Field Name": err[j]?.received,
                Error: "Invalid Header",
              });
            }
          }
  
          if (error?.type === "INVALID_CONTENT") {
            const err = error?.data || [];
            for (let j = 0; j < err.length; j++) {
              const rowErrors = err[j]?.data || [];
              for (let k = 0; k < rowErrors.length; k++) {
                fieldError.push({
                  Row: err[j]?.index,
                  "Field Name": rowErrors[k]?.headerKey,
                  Error: "Invalid Content",
                  Note: rowErrors[k]?.note,
                });
              }
            }
          }
  
          if (error?.type === "SOW_NUMBER_EXIST" || error?.type === "PO_NUMBER_EXIST") {
            const err = error?.data || [];
            for (let j = 0; j < err.length; j++) {
              fieldError.push({
                Row: err[j]?.index,
                "Field Name": err[j]?.headerKey,
                Note: err[j]?.errorMessage,
              });
            }
          }
  
          if (error?.type === "CONFIGURATION_NOT_EXIST") {
            const err = error?.data?.[0]?.data || [];
            const ids = error?.data?.[0]?.index || [];
  
            for (let j = 0; j < err.length; j++) {
              const msg: string[] = [];
              const errorKeys = err[j]?.error.split(",") || [];
  
              errorKeys.forEach((key: any) => {
                msg.push(`Please check ${key} is valid`);
              });
  
              fieldError.push({
                Row: ids[j],
                "Field Name": errorKeys.join(", "),
                Error: msg.join(",\n"),
              });
            }
          }
  
          console.log("Final Error Rows:", fieldError);

          setErrorData(fieldError);
        }else{
          setResultLoading(false);
          setImportSuccess(false);
          setImportError(true);
        }

      });
    }
    };
  
    const formProps = {
      form: form,
      name: "project-bulk-upload",
      heading: "Project Bulk Import",
      initialValues: {},
      formElements: [
        // Add more form elements as needed
      ],
      onFinish: onFinish,
      // onFinishFailed: onFinishFailed,
      // onValuesChange: onValuesChange,
    };
  
    const getColumnHeaders = (errorData: any[]) => {
      // Extracting column names from the first row of errorData
      const columns = Object.keys(errorData[0]).map((columnName) => ({
        title: columnName,
        dataIndex: columnName,
        key: columnName,
      }));
      return columns;
    };
  
    const getRowData = (errorData: any[]) => {
      console.log(errorData, "errorData");
      // Extracting row data from errorData
      const rowData = errorData.map((row, index) => ({
        ...row,
        key: index, // Assigning a unique key to each row
      }));
      return rowData;
    };
  
    const renderPhaseContent = () => {
      switch (currentPhase) {
        case "preparation":
          return (
            <div>
              <h3>Preparation</h3>
              <Card
                style={{
                  borderRadius: 8,
                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                  backgroundColor: "#e6f7ff",
                }}
              >
                <p style={{ fontSize: "14px" }}>
                  <ExclamationCircleOutlined /> Reminder:
                </p>
                <p style={{ fontSize: "12px" }}>
                  Please make sure to use the latest version of the template to
                  pass the validation check.
                </p>
                <Button
                  type="primary"
                  style={{ marginBottom: 16 }}
                  onClick={handleDownloadTemplate}
                >
                  <ArrowDownOutlined /> Download Template
                </Button>
              </Card>
              <Divider />
              <div style={{ maxWidth: 400, backgroundColor: "#dcdcdc" ,marginBottom: "30px"}}>
                <Upload.Dragger
                  name="file"
                  multiple={true}
                  listType="picture"
                  showUploadList={false}
                  // beforeUpload={handleBeforeUpload}
                  customRequest={handleUploadChange}
                  style={{ padding: "16px 0", backgroundColor: "#dcdcdc" }}
                  accept=".csv"
                >
                  <p className="ant-upload-drag-icon">
                    <InboxOutlined />
                  </p>
                  <p className="ant-upload-text">
                    Click or drag file to this area to upload
                  </p>
                </Upload.Dragger>
              </div>
              {fileList?.length > 0 && (
                <Table
                  columns={columns}
                  dataSource={fileList}
                  pagination={false}
                  style={{ background: "#e0e0e0" }}
                />
              )}
              {/* <GenericFormComponent {...formProps} /> */}
              <Row justify="end" style={{ marginTop: 16 }}>
                <Col>
                  <Space>
                    <Button onClick={onClose}>Cancel</Button>
                    <Button
                      type="primary"
                      onClick={handleNext}
                      disabled={parsedData?.length === 0}
                    >
                      Submit
                    </Button>
                  </Space>
                </Col>
              </Row>
            </div>
          );
        case "processing":
          return (
            <div>
              <h3>Processing</h3>
              <br></br>
              {errorData?.length > 0 && (
                <Card
                  style={{
                    borderRadius: 8,
                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0)",
                    backgroundColor: "#ffe6e6",
                    height: 70,
                    marginBottom: "30px",
                  }}
                >
                  <p style={{ fontSize: "14px" }}>
                    <WarningOutlined style={{ color: "red" }} /> Field Error: Fix
                    the following templates field and upload the file again
                  </p>
                </Card>
              )}
              {errorData?.length > 0 && (
                <Table
                  columns={getColumnHeaders(errorData)}
                  dataSource={getRowData(errorData)}
                  pagination={false}
                />
              )}
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontSize: "5em",
                }}
              >
                {importSuccess && !resultLoading && !importError && (
                  <Card
                    style={{
                      borderRadius: 8,
                      boxShadow: "0 4px 8px rgba(0, 0, 0, 0)",
                      backgroundColor: "#e6ffe6",
                      width: "flex",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        fontSize: "5em",
                      }}
                    >
                      <CheckCircleOutlined style={{ color: "green" }} />
                    </div>
                    <br></br>
                    <p style={{ fontSize: "15px" }}>
                      Successfully uploaded all projects
                    </p>
                  </Card>
                )}
                {!importSuccess && !resultLoading && importError && (
                  <Card
                    style={{
                      borderRadius: 8,
                      boxShadow: "0 4px 8px rgba(0, 0, 0, 0)",
                      backgroundColor: "#ffe6e6",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        fontSize: "5em",
                      }}
                    >
                      <CloseCircleOutlined style={{ color: "red" }} />
                    </div>
                    <br></br>
                    <p style={{ fontSize: "15px" }}>
                      Project Bulk Import Failed. Please try again.
                    </p>
                  </Card>
                )}
  
                {resultLoading && !importSuccess && !importError && <Spin size="large"></Spin>}
              </div>
              <Row justify="end" style={{ marginTop: 16 }}>
                <Col>
                  <Space>
                    {!importSuccess && !importError && (
                      <Button onClick={handlePrevious}>Previous</Button>
                    )}
                    {/* <Button onClick={onSubmit} type="primary">
                      Submit
                    </Button> */}
                    <Button onClick={onClose}>Close</Button>
                  </Space>
                </Col>
              </Row>
            </div>
          );
        default:
          return null;
      }
    };
  
    const handleBeforeUpload = (file: File) => {
      // // Check file type and size
      const isCSV = file.type === "text/csv";
      if (!isCSV) {
        showNotification("You can only upload CSV files!", "error");
        return false; // Prevent upload
      }
      // const isLt2M = file.size / 1024 / 1024 < 2;
      // if (!isLt2M) {
      //   message.error("File must be smaller than 2MB!");
      //   return false; // Prevent upload
      // }
      return true; // Allow upload
    };
  
    const handleUploadChange = async (info: any) => {
      const { file } = info;
      if (file) {
        console.log(info.file);
        setFileList([file]);
        showNotification(
          `${info.file.name} file uploaded successfully.`,
          "success"
        );
        let reader = new FileReader();
        reader.readAsText(file);
        reader.onload = async () => {
          let csv = reader.result;
          Papa.parse(csv, {
            header: true,
            skipEmptyLines: true,
            complete: async (result: { data: any }, file: any) => {
              const dataList = result.data;
              setnumberRowCSV(dataList?.length);
              if (dataList?.length === 0) {
                showNotification(
                  `Required minimum one row to process project bulk import`,
                  "warning"
                );
                setParsedData([]);
              } 
              else {
                
                setParsedData(dataList); 
                  
              }
              console.log(dataList);
            },
          });
        };
      } else {
        showNotification(`${info.file.name} file upload failed.`, "error");
        console.log(info.file);
      }
    };
  
    return (
      <>
        <Drawer
          maskClosable={false}
          title={<strong>{formProps.heading}</strong>}
          className="form-drawer"
          width={
            screenType.isPortrait
              ? "90%" // Adjust width based on screen orientation
              : screenType.isLg || screenType.isXl
              ? 720
              : 500
          }
          onClose={onClose}
          open={visible}
        >
          {renderPhaseContent()}
        </Drawer>
      </>
    );
  };
  
  export default ProjectBulkUploadComponent;
  